<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "ClModal",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
    scrim: {
      type: Boolean,
      default: false,
    },
    persistent:{
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: [String, Number],
      default: 900,
    },
    width: {
      type: String,
      default: 'auto',
    },
    blur: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['update:modelValue'],
  data(){
    return {
      value: false
    }
  },
  watch: {
    modelValue: {
      handler: function (value){
        this.value = value;
      },
      immediate: true,
    },
  },
  methods: {
    close(){
      this.value = false;
      this.$emit('update:modelValue', false)
    }
  }

})
</script>

<template>
  <v-dialog
      v-model="value"
      :fullscreen="fullScreen"
      :scrim="scrim"
      :width="width"
      :max-width="maxWidth"
      :class="{'blur': blur}"
      transition="dialog-bottom-transition"
      :persistent="persistent"
  >
    <v-btn height="30" size="x-small" rounded position="absolute" class="mt-n3 mr-n3 rounded-lg" variant="flat" style="z-index: 1001" @click="close">
      <v-icon icon="$close" size="large"></v-icon>
    </v-btn>
      <slot />
  </v-dialog>
</template>

<style scoped>

</style>
